module.exports = BetterScroll;